if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Create store selector modal on initialization
        this.createStoreModal();

        if (localStorage.getItem("uniqueEventShare")) {
          const lsJson = JSON.parse(localStorage.getItem("uniqueEventShare"));
          let allCollectionIds = this.form.querySelector('[name="properties[_collection_id]"]').value;
          if (allCollectionIds) {
            allCollectionIds.split(',').forEach((collectionId) => {
              const foundObject = lsJson.find(item => item.event.some(event => event.collectionId === collectionId));
              if (foundObject) {
                let volunteerId = foundObject.vol;
                var newInput = document.createElement('input');
                newInput.type = 'hidden';
                newInput.name = 'properties[_volunteer_id]';
                newInput.value = volunteerId;
                this.form.appendChild(newInput);
                var eventIdInput = document.createElement('input');
                eventIdInput.type = 'hidden';
                eventIdInput.name = 'properties[_event_uuid_id]';
                eventIdInput.value = foundObject?.event[0]?.eventId;
                this.form.appendChild(eventIdInput);
              }
            });
          }
        }
      }

      createStoreModal() {
        if (document.getElementById('storeSelectorModal')) return;

        const style = document.createElement('style');
        style.textContent = `
          #storeSelectorModal {
            display: none; position: fixed; top: 0; left: 0;
            width: 100%; height: 100%;
            background: rgba(0,0,0,0.5);
            z-index: 99999;
            justify-content: center; align-items: center;
          }
          #storeSelectorModal .ssm-box {
            background: #fff; border-radius: 16px;
            padding: 28px 24px 24px;
            max-width: 460px; width: 92%;
            max-height: 90vh; overflow-y: auto;
            box-shadow: 0 20px 60px rgba(0,0,0,0.2);
            animation: ssmSlideIn 0.25s ease-out;
          }
          @keyframes ssmSlideIn {
            from { opacity: 0; transform: translateY(-16px); }
            to   { opacity: 1; transform: translateY(0); }
          }
          #storeSelectorModal .ssm-header {
            display: flex; justify-content: space-between;
            align-items: flex-start; margin-bottom: 4px;
          }
          #storeSelectorModal .ssm-title {
            font-size: 20px; font-weight: 600; color: #111; margin: 0;
          }
          #storeSelectorModal .ssm-sub {
            font-size: 14px; color: #666; margin: 6px 0 18px;
          }
          #storeSelectorModal .ssm-close {
            background: none; border: none; font-size: 22px;
            cursor: pointer; color: #999; line-height: 1;
            padding: 0 2px; margin-left: 12px; flex-shrink: 0;
          }
          #storeSelectorModal .ssm-close:hover { color: #333; }
          #storeSelectorModal .ssm-search-wrap {
            position: relative; margin-bottom: 16px;
          }
          #storeSelectorModal .ssm-search-icon {
            position: absolute; left: 11px; top: 50%;
            transform: translateY(-50%);
            width: 15px; height: 15px; color: #aaa; pointer-events: none;
          }
          #storeSelectorModal .ssm-search {
            width: 100%; padding: 10px 12px 10px 34px;
            font-size: 14px; border: 1px solid #e0e0e0;
            border-radius: 8px; outline: none;
            background: #f7f7f7; color: #111;
            transition: border-color 0.15s, background 0.15s;
            box-sizing: border-box;
          }
          #storeSelectorModal .ssm-search:focus {
            border-color: #aaa; background: #fff;
          }
          #storeSelectorModal .ssm-section-label {
            font-size: 11px; font-weight: 600; color: #aaa;
            text-transform: uppercase; letter-spacing: 0.06em;
            margin-bottom: 10px;
          }
          #storeSelectorModal .ssm-list {
            display: flex; flex-direction: column; gap: 6px;
            max-height: 260px; overflow-y: auto;
          }
          #storeSelectorModal .ssm-list::-webkit-scrollbar { width: 4px; }
          #storeSelectorModal .ssm-list::-webkit-scrollbar-track { background: transparent; }
          #storeSelectorModal .ssm-list::-webkit-scrollbar-thumb { background: #ddd; border-radius: 4px; }
          #storeSelectorModal .ssm-item {
            display: flex; align-items: center; gap: 12px;
            padding: 10px 12px; border-radius: 10px;
            border: 1px solid #eee; cursor: pointer;
            transition: background 0.15s, border-color 0.15s;
            background: #fff;
          }
          #storeSelectorModal .ssm-item:hover {
            background: #f5f5f5; border-color: #ccc;
          }
          #storeSelectorModal .ssm-item.selected {
            border-color: #378ADD; background: #EAF3FF;
          }
          #storeSelectorModal .ssm-avatar {
            width: 70px; height: 70px; border-radius: 50%;
            display: flex; align-items: center; justify-content: center;
            font-size: 14px; font-weight: 600; flex-shrink: 0;
            overflow: hidden;
          }
          #storeSelectorModal .ssm-avatar img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
          #storeSelectorModal .ssm-info { flex: 1; min-width: 0; }
          #storeSelectorModal .ssm-name {
            font-size: 14px; font-weight: 500; color: #111;
            white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
            margin: 0 0 2px;
          }
          #storeSelectorModal .ssm-meta {
            font-size: 12px; color: #888;
            display: flex; gap: 10px; align-items: center;
          }
          #storeSelectorModal .ssm-featured-badge {
               font-size: 9px;
    font-weight: 600;
    color: #fff;
    background: #e8443a;
    padding: 1px 6px;
    border-radius: 4px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
          }
          #storeSelectorModal .ssm-check {
            width: 20px; height: 20px; border-radius: 50%;
            border: 1.5px solid #ddd;
            display: flex; align-items: center; justify-content: center;
            flex-shrink: 0; transition: background 0.15s, border-color 0.15s;
          }
          #storeSelectorModal .ssm-item.selected .ssm-check {
            background: #e8443a; border-color: #e8443a;
          }
          #storeSelectorModal .ssm-check svg { display: none; }
          #storeSelectorModal .ssm-item.selected .ssm-check svg { display: block; }
          #storeSelectorModal .ssm-skeleton {
            display: flex; align-items: center; gap: 12px;
            padding: 10px 12px; border-radius: 10px;
            border: 1px solid #f0f0f0; background: #fafafa;
          }
          #storeSelectorModal .ssm-skeleton-avatar {
            width: 40px; height: 40px; border-radius: 50%;
            background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
            background-size: 200% 100%; animation: ssmShimmer 1.2s infinite;
            flex-shrink: 0;
          }
          #storeSelectorModal .ssm-skeleton-line {
            height: 10px; border-radius: 4px;
            background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
            background-size: 200% 100%; animation: ssmShimmer 1.2s infinite;
          }
          @keyframes ssmShimmer {
            0% { background-position: 200% 0; }
            100% { background-position: -200% 0; }
          }
          #storeSelectorModal .ssm-no-results {
            font-size: 13px; color: #999; text-align: center;
            padding: 24px 0; display: none;
          }
          #storeSelectorModal .ssm-footer {
            display: flex; gap: 8px; margin-top: 18px;
          }
          #storeSelectorModal .ssm-cancel {
            flex: 1; padding: 11px; font-size: 14px;
            background: none; border: 1px solid #e0e0e0;
            border-radius: 8px; cursor: pointer; color: #666;
            transition: background 0.15s;
          }
          #storeSelectorModal .ssm-cancel:hover { background: #f5f5f5; }
          #storeSelectorModal .ssm-confirm {
            flex: 2; padding: 11px; font-size: 14px; font-weight: 600;
            background: #111; color: #fff; border: none;
            border-radius: 8px; cursor: pointer;
            opacity: 0.3; pointer-events: none;
            transition: opacity 0.15s, background 0.15s;
          }
          #storeSelectorModal .ssm-confirm.active {
            opacity: 1; pointer-events: all;
          }
          #storeSelectorModal .ssm-confirm.adding {
            opacity: 0.6; pointer-events: none;
          }
          #storeSelectorModal .ssm-error {
            font-size: 12px; color: #c0392b; text-align: center;
            margin-top: 8px; display: none;
          }
        `;
        document.head.appendChild(style);

        const html = `
          <div id="storeSelectorModal">
            <div class="ssm-box">
              <div class="ssm-header">
                <div>
                  <p class="ssm-title">Select a store</p>
                  <p class="ssm-sub">Choose the store you're supporting to continue</p>
                </div>
                <button class="ssm-close" id="ssmClose" aria-label="Close">&#x2715;</button>
              </div>
              <div class="ssm-search-wrap">
                <svg class="ssm-search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
                </svg>
                <input class="ssm-search" id="ssmSearch" type="text" placeholder="Search by name or store code…" autocomplete="off">
              </div>
              <div class="ssm-section-label" id="ssmLabel">Featured stores</div>
              <div class="ssm-list" id="ssmList"></div>
              <div class="ssm-no-results" id="ssmNoResults">No stores found. Try a different search.</div>
              <p class="ssm-error" id="ssmError">Something went wrong loading stores. Please try again.</p>
              <div class="ssm-footer">
                <button class="ssm-cancel" id="ssmCancel">Cancel</button>
                <button class="ssm-confirm" id="ssmConfirm">Add to cart</button>
              </div>
            </div>
          </div>
        `;
        document.body.insertAdjacentHTML('beforeend', html);

        // Avatar color palette — cycles through for stores
        this._ssmAvatarColors = [
          { bg: '#E6F1FB', text: '#0C447C' },
          { bg: '#EAF3DE', text: '#3B6D11' },
          { bg: '#FAECE7', text: '#993C1D' },
          { bg: '#EEEDFE', text: '#3C3489' },
          { bg: '#FAEEDA', text: '#854F0B' },
          { bg: '#E1F5EE', text: '#085041' },
          { bg: '#FBEAF0', text: '#72243E' },
        ];

        this._ssmAllStores    = [];
        this._ssmSelectedCode = null;
        this._ssmPendingForm  = null;

        const modal      = document.getElementById('storeSelectorModal');
        const listEl     = document.getElementById('ssmList');
        const searchEl   = document.getElementById('ssmSearch');
        const labelEl    = document.getElementById('ssmLabel');
        const noResults  = document.getElementById('ssmNoResults');
        const errorEl    = document.getElementById('ssmError');
        const confirmBtn = document.getElementById('ssmConfirm');

        // Store refs on instance for showStoreModal access
        this._ssmModal      = modal;
        this._ssmConfirmBtn = confirmBtn;
        this._ssmSearchEl   = searchEl;
        this._ssmLabelEl    = labelEl;
        this._ssmListEl     = listEl;
        this._ssmNoResults  = noResults;
        this._ssmErrorEl    = errorEl;

        // ── Render skeleton loaders ──────────────────────────────────────
        const showSkeletons = () => {
          listEl.innerHTML = Array(5).fill(0).map(() => `
            <div class="ssm-skeleton">
              <div class="ssm-skeleton-avatar"></div>
              <div style="flex:1;display:flex;flex-direction:column;gap:6px">
                <div class="ssm-skeleton-line" style="width:65%"></div>
                <div class="ssm-skeleton-line" style="width:40%"></div>
              </div>
            </div>
          `).join('');
        };

        // ── Render store items ──────────────────────────────────────────
        const renderStores = (stores) => {
          if (!stores.length) {
            listEl.innerHTML = '';
            noResults.style.display = 'block';
            return;
          }
          noResults.style.display = 'none';

          listEl.innerHTML = stores.map((s, i) => {
            const color    = this._ssmAvatarColors[i % this._ssmAvatarColors.length];
            const initials = s.displayFirstName
              ? s.displayFirstName.substring(0, 2).toUpperCase()
              : (s.storeCode || 'ST').substring(0, 2).toUpperCase();
            const isSelected = this._ssmSelectedCode === s.storeCode;
            const raisedFmt  = s.raisedAmount > 0
              ? `$${Math.round(s.raisedAmount).toLocaleString()} raised`
              : '';
            const featuredBadge = s.isFeatured
              ? `<span class="ssm-featured-badge">Featured</span>`
              : '';

            return `
              <div class="ssm-item${isSelected ? ' selected' : ''}" data-code="${s.storeCode}">
                <div class="ssm-avatar" style="background:${color.bg};color:${color.text}">
                <img src="${s.imageUrl}" />
                </div>
                <div class="ssm-info">
                  <p class="ssm-name">${s.displayFirstName ? s.displayFirstName + "'s Store" : s.storeCode}</p>
                  <div class="ssm-meta">
                    <span>${s.storeCode}</span>
                    ${raisedFmt ? `<span>${raisedFmt}</span>` : ''}
                    ${featuredBadge}
                  </div>
                </div>
                <div class="ssm-check">
                  <svg width="10" height="8" viewBox="0 0 12 10" fill="none" stroke="#fff" stroke-width="2.5">
                    <polyline points="1,5 4,8 11,1"/>
                  </svg>
                </div>
              </div>
            `;
          }).join('');

          listEl.querySelectorAll('.ssm-item').forEach(el => {
            el.addEventListener('click', () => {
              this._ssmSelectedCode = el.dataset.code;
              confirmBtn.classList.add('active');
              renderStores(this._ssmCurrentList);
            });
          });
        };

        this._ssmRenderStores = renderStores;

        // ── Search ──────────────────────────────────────────────────────
        let searchTimeout = null;
        searchEl.addEventListener('input', () => {
          clearTimeout(searchTimeout);
          searchTimeout = setTimeout(() => {
            const q = searchEl.value.toLowerCase().trim();
            if (!q) {
              this._ssmCurrentList = this._ssmAllStores;
              labelEl.textContent  = 'Featured stores';
            } else {
              this._ssmCurrentList = this._ssmAllStores.filter(s =>
                (s.displayFirstName && s.displayFirstName.toLowerCase().includes(q)) ||
                (s.storeCode && s.storeCode.toLowerCase().includes(q))
              );
              labelEl.textContent = `Search results (${this._ssmCurrentList.length})`;
            }
            renderStores(this._ssmCurrentList);
          }, 200);
        });

        // ── Close ───────────────────────────────────────────────────────
        const closeModal = () => {
          modal.style.display = 'none';
          this._ssmSelectedCode = null;
          this._ssmPendingForm  = null;
          searchEl.value        = '';
          labelEl.textContent   = 'Featured stores';
          confirmBtn.classList.remove('active', 'adding');
          confirmBtn.textContent = 'Add to cart';
          this._ssmCurrentList  = this._ssmAllStores;
          renderStores(this._ssmAllStores);
        };

        document.getElementById('ssmClose').addEventListener('click', closeModal);
        document.getElementById('ssmCancel').addEventListener('click', closeModal);
        modal.addEventListener('click', e => { if (e.target === modal) closeModal(); });
        document.addEventListener('keydown', e => {
          if (e.key === 'Escape' && modal.style.display === 'flex') closeModal();
        });

        // ── Confirm — inject code and resubmit ─────────────────────────
        confirmBtn.addEventListener('click', () => {
          if (!this._ssmSelectedCode || !this._ssmPendingForm) return;

          confirmBtn.textContent = 'Adding to cart…';
          confirmBtn.classList.add('adding');
          confirmBtn.classList.remove('active');

          let codeInput = this._ssmPendingForm.querySelector('[name="properties[_store_code]"]');
          if (!codeInput) {
            codeInput = document.createElement('input');
            codeInput.type  = 'hidden';
            codeInput.name  = 'properties[_store_code]';
            this._ssmPendingForm.appendChild(codeInput);
          }
          codeInput.value = this._ssmSelectedCode;

          const form = this._ssmPendingForm;
          closeModal();
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        });

        // ── Fetch stores from API ───────────────────────────────────────
        this._ssmLoadStores = () => {
          showSkeletons();
          errorEl.style.display = 'none';

          fetch(`${window.apiUrl}api/active/store`, {
            method: 'GET',
            mode: 'cors',
          })
            .then(r => r.json())
            .then(response => {
              let stores = (response?.data?.data || []);

              // Filter: only stores with raisedAmount > 0
              stores = stores.filter(s => s.raisedAmount > 0);

              // Sort: featured first, then by raisedAmount desc
              stores.sort((a, b) => {
                if (a.isFeatured && !b.isFeatured) return -1;
                if (!a.isFeatured && b.isFeatured) return 1;
                return b.raisedAmount - a.raisedAmount;
              });

              this._ssmAllStores   = stores;
              this._ssmCurrentList = stores;
              renderStores(stores);
            })
            .catch(() => {
              listEl.innerHTML = '';
              errorEl.style.display = 'block';
            });
        };
      }

      showStoreModal(form) {
        this._ssmPendingForm  = form;
        this._ssmSelectedCode = null;
        this._ssmConfirmBtn.classList.remove('active', 'adding');
        this._ssmConfirmBtn.textContent = 'Add to cart';
        this._ssmSearchEl.value  = '';
        this._ssmLabelEl.textContent = 'Featured stores';
        this._ssmModal.style.display = 'flex';

        // Load stores (fresh fetch each time modal opens)
        this._ssmLoadStores();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // Validate store code
        const storeCodeInput = this.form.querySelector('[name="properties[_store_code]"]');
        const storeCodeValue = storeCodeInput ? storeCodeInput.value.trim() : '';

        if (!storeCodeValue) {
          this.showStoreModal(this.form);
          return;
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}